import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/cta/cta-appontment/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/partials/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/partials/card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/partials/contactForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/partials/diagonalSection/index.tsx");
